import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
//Sections
import ShortTextField from "../../fields/ShortTextField";
import EmailTextField from "../../fields/EmailTextField";
import LongTextField from "../../fields/LongTextField";
import DateTextField from "../../fields/DateTextField";
import RadioTextField from "../../fields/RadioTextField";
const useStyles = makeStyles(() => ({
  checksContainer: {
    marginLeft: 48,
    marginRight: 48
  }
}));
const FIELD_MAPPING = {
  "short-text": ShortTextField,
  email: EmailTextField,
  "long-text": LongTextField,
  date: DateTextField,
  "radio-button": RadioTextField
};
const ClientChecksTemplate = ({
  check,
  onCheckValueChange = () => null,
  readOnly,
  checksContainer = ""
}) => {
  const classes = useStyles();
  if (!check || !check.render) {
    return null;
  }
  const {
    render: {
      fieldType
    },
    description,
    title
  } = check;
  check.value = check.value === null ? "" : check.value;
  const Field = FIELD_MAPPING[fieldType];
  return /*#__PURE__*/React.createElement(Grid, {
    className: checksContainer !== "" ? checksContainer : classes.checksContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    component: Typography,
    color: "textPrimary",
    variant: "subtitle2"
  }, title), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    component: Typography,
    style: {
      marginTop: 16
    },
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      marginTop: 24
    }
  }, Field ? /*#__PURE__*/React.createElement(Field, {
    check: check,
    onChange: onCheckValueChange,
    readOnly: readOnly
  }) : "field mapping missing"));
};
export default ClientChecksTemplate;
ClientChecksTemplate.propTypes = {
  check: PropTypes.object.isRequired,
  onCheckValueChange: PropTypes.func,
  readOnly: PropTypes.bool.isRequired,
  checksContainer: PropTypes.string
};